import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "card-radius-square settings-btn card-style-btn",
    id: "card-radius-square",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCardStyleRadius && _ctx.toggleCardStyleRadius(...args)))
  }, _cache[1] || (_cache[1] = [
    _createTextVNode(" Click To "),
    _createElementVNode("span", { class: "square" }, "Square", -1),
    _createElementVNode("span", { class: "radius" }, "Radius", -1)
  ])))
}